import React, { useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Topnav } from 'components';
import { authContextHelper } from 'utilities';
import RouteDefinitions from './RouteDefinitions';
import { HelmetProvider, Helmet } from 'react-helmet-async';
import MobileRouteDefinitions from '../mobile/routes/mobileRouteDefinitions';
//import * as helpers from 'utilities/helpers';


interface RoutesProps {
  mobile: boolean;
  mobileEnabled: boolean;
}
const Routes: React.FC<RoutesProps> = ({ mobile, mobileEnabled }) => {

  const [showSearchBar, setShowTopSearchBar] = useState(false);
  
  return (
    <>
      <HelmetProvider>
        <BrowserRouter>
          <authContextHelper.AuthProvider>
            <div className="app">
              {mobile ? (
                <>
                  <Helmet
                    bodyAttributes={{
                      class: 'main-bg main-bg-opac main-bg-blur adminuiux-sidebar-boxed theme-blue roundedui adminuiux-sidebar-fill-bg bg-default scrolldown adminuiux-header-boxed k-background',
                      'data-bs-spy': 'scroll',
                      'data-theme': 'theme-blue',
                      'data-sidebarfill': 'adminuiux-sidebar-fill-bg',
                      'data-bs-smooth-scroll': 'true',
                      tabIndex: 0,
                      'data-headerlayout': 'adminuiux-header-boxed',
                      'data-bggradient': 'bg-default'
                    }}
                  >
                    <title>K Mobile</title>
                    <meta name="viewport" content="width=device-width, initial-scale=1.0, viewport-fit=cover"/>
                    <meta httpEquiv="x-ua-compatible" content="ie=edge"/>
                    <link rel="preconnect" href="https://fonts.googleapis.com" crossOrigin="anonymous"/>
                    <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous"/>
                    <link href="https://fonts.googleapis.com/css2?family=Fira+Sans+Condensed:wght@100;400;500;600&family=Roboto:ital,wght@0,300;0,400;0,500;0,700;1,400&display=swap" rel="stylesheet"/>
                    <style>
                      {`:root {
                        --adminuiux-content-font: 'Roboto';
                        --adminuiux-content-font-weight: 400;
                        --adminuiux-title-font: "Fira Sans Condensed";
                        --adminuiux-title-font-weight: 500;
                      }`}
                    </style>

                  </Helmet>
                  
                  <MobileRouteDefinitions setShowTopSearchBar={setShowTopSearchBar} mobileEnabled={mobileEnabled}/>
                </>
              ) : (
                <>
                  <Topnav
                    navClass="bg-white navbar-light k-z-ind-10"
                    isSticky={true}
                    showTopSearchBar={showSearchBar}
                  />
                  <div className='k-fg-1'>
                    <RouteDefinitions setShowTopSearchBar={setShowTopSearchBar} />
                  </div>
                  {/*<Footermain />*/}
                </>
              )}
            </div>
          </authContextHelper.AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
    </>
  );
};

export default Routes;